// extracted by mini-css-extract-plugin
export default {"button":"CalcButton_button__0nZpD"};